// Constant variables used  in the Figure editor and figure exports

export const ASPECT_RATIO = Math.round((8.5 / 11) * 100) / 100;
export const FONT_SIZE = 13.3333333;
export const FIG_FONT_SIZE = 32;
// Unit size is the pixel message of a single grid on the diagram canvas
export const UNIT_SIZE = 12;
export const VISIO_UNIT_SIZE = 0.125;
export const TOP_PADDING = 8;
export const SIDE_PADDING = 9;
export const FIG_TAG_START = `<span class='figLabel'>`;
export const FIG_TAG_END = `</span>`;
export const WORKSPACE_WIDTH = 50;
export const WORKSPACE_HEIGHT = 70;
export const PANEL_WIDTH = 68;
export const PANEL_HEIGHT = 88;
export const FIG_STYLE = `fontColor=black;fontStyle=3;fontSize=${FIG_FONT_SIZE};strokeColor=none;fill=none;editable=1;autosize=1;movable=0;selectable=0;resizable=0`;
export const FIG_WIDTH = 9;
export const FIG_HEIGHT = 3;
export const FIG_PADDING = 3;
export const FIG_X = (SIDE_PADDING + WORKSPACE_WIDTH / 2 - FIG_WIDTH / 2) * UNIT_SIZE;
export const FIG_Y = (TOP_PADDING + WORKSPACE_HEIGHT + FIG_PADDING) * UNIT_SIZE;
export const STANDARD_WIDTH = PANEL_WIDTH * UNIT_SIZE;
export const STANDARD_HEIGHT = PANEL_HEIGHT * UNIT_SIZE;
export const BLOCK_PARENT_STYLE =
  'whiteSpace=wrap;align=left;verticalAlign=top;overflow=hidden;editable=0;movable=0;selectable=0;resizable=0';
export const BLOCK_CHILD_STYLE =
  'whiteSpace=wrap;overflow=hidden;editable=0;movable=0;selectable=0;resizable=0';
export const BLOCK_PILL_STYLE =
  'whiteSpace=wrap;overflow=hidden;rounded=1;editable=0;movable=0;selectable=0;resizable=0';
export const BLOCK_IMG_STYLE = `editable=0;movable=0;selectable=0;resizable=0;shape=image;imageAlign=center;aspect=fixed`;
export const BLOCK_LABEL_STYLE =
  'shape=callout;direction=0;editable=0;align=right;selectable=1;resizable=1;fill=none';
export const BLOCK_LABEL_BOTTOM_RIGHT =
  'shape=callout;direction=1;editable=0;align=left;selectable=1;resizable=1;fill=none';
export const BLOCK_LABEL_TOP_LEFT =
  'shape=callout;direction=2;editable=0;align=right;selectable=1;resizable=1;fill=none';
export const BLOCK_LABEL_TOP_RIGHT =
  'shape=callout;direction=3;editable=0;align=left;selectable=1;resizable=1;fill=none';
export const BLOCK_LABEL_NO_CALLOUT =
  'shape=callout;direction=5;editable=0;align=right;selectable=1;resizable=1;fill=none';
export const DEFAULT_STROKE_COLOR = '#000000';
export const DEFAULT_FILL_COLOR = '#ffffff';
export const DEFAULT_FONT_COLOR = '#000000';
export const DEFAULT_STROKE_WIDTH = 1;
export const DEFAULT_FONT_FAMILY = 'Times New Roman, Arial, sans-serif';
export const DEFAULT_LABEL_PADDING = 3;
export const DEFAULT_EDGE_CURVE = 0;

// Line types
export const UNDIRECTED = 'UNDIRECTED';
export const BIDIRECTED = 'BIDIRECTED';
export const OUTBOUND = 'OUTBOUND';
export const INBOUND = 'INBOUND';

// Line arrow styles
export const STYLE_UNDIRECTED = 'endArrow=none;startArrow=none;';
export const STYLE_BIDIRECTED = 'endArrow=classic;startArrow=classic;';
export const STYLE_OUTBOUND = 'endArrow=classic;startArrow=none';
export const STYLE_INBOUND = 'endArrow=none;startArrow=classic';

export const SHAPE_PILL = 'PILL';
export const SHAPE_RECTANGLE = 'RECTANGLE';
export const SHAPE_LABEL = 'LABEL';
